import { render, staticRenderFns } from "./prompt-item-form.vue?vue&type=template&id=11c21eec"
import script from "./prompt-item-form.vue?vue&type=script&lang=js"
export * from "./prompt-item-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports